<bwh-lib-step-control-bar
  [langDropdown]="true"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
></bwh-lib-step-control-bar>
<lib-file-upload
  class="scrollable-content"
  [title]="'global.upload_title' | translate"
  [subTitle]="'global.upload_subtitle' | translate"
  [fileTypes]="fileTypes"
  (fileUploaded)="getUploadedFile($event)"
>
  <ng-template #buttons>
    <input
      type="file"
      #fileDropRef
      id="fileDropRef"
      accept=".pdf,application/pdf"
      (change)="handleFileUpload($event)"
      class="d-none"
    />
    <ul class="upload-buttons upload-buttons--cards">
      <li>
        <lib-select-card
          (click)="fileDropRef.click()"
          [icon]="'/assets/icons/cv-icon.svg'"
          [title]="'global.your_cv' | translate"
          [description]="'global.your_cv_description' | translate"
        >
          <span class="select-card-badge select-card-badge--recommended">{{ 'global.recommended' | translate }}</span>
        </lib-select-card>
      </li>
      <li>
        <lib-select-card
          (click)="manualCv()"
          [icon]="'/assets/icons/occupations-icon.svg'"
          [title]="'global.your_occupations' | translate"
          [description]="'global.your_occupations_description' | translate"
        >
          <span class="select-card-badge select-card-badge--without-cv">{{ 'global.without_cv' | translate }}</span>
        </lib-select-card>
      </li>
    </ul>
  </ng-template>
</lib-file-upload>
